import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath, setUrlId } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import { isManager } from '../../../utils/role'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSubRisk: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
    risk,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  const [isOpenMember, setIsOpenMember] = useState<boolean>(false)
  const [isOpenTeam, setIsOpenTeam] = useState<boolean>(false)

  return (
    <>
      {
        location.pathname.match(URL.RISK.path) && isManager(login.role) && login.function_enabled_state?.risk_assessment ? (
          <div className="side_sub_wrap">
            <div className="tools">
              <div className="calendar_text">
                <div />
                <button
                  type="button"
                  className={`menu_toggle ${isOpen && "display"}`}
                  onClick={() => toggleCallback()}
                >
                  <div className={`menu ${isOpen && "active"}`}>
                    <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                  </div>
                </button>
              </div>
            </div>
            <section className="side_sub">
              <Link
                to={setPath(URL.RISK_TIMELINE.path, language)}
                className={classNames({
                  active: location.pathname.match(URL.RISK_TIMELINE.path),
                  item: true,
                })}
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-right']}
                    className="arrow_icon"
                  />
                  <div className="name_area">
                    <FontAwesomeIcon
                      icon={['fas', 'clock']}
                      className="icon task"
                    />
                    タイムライン
                  </div>
                </div>
              </Link>
              <div
                className="item folder"
                onClick={() => setIsOpenMember(!isOpenMember)}
                role="none"
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-down']}
                    className={`arrow_icon ${isOpenMember && "open"}`}
                  />
                  <div className="name_area">
                    <FontAwesomeIcon
                      icon={['fas', 'user']}
                      className="icon task"
                    />
                    個人データ
                  </div>
                </div>
              </div>
              <div className={`${isOpenMember || "hidden none"}`}>
                <Link
                  to={setPath(URL.RISK_MEMBER_LIST.path, language)}
                  className={classNames({
                    active: location.pathname.match(URL.RISK_MEMBER_LIST.path),
                    item: true,
                    indent_1: true,
                  })}
                >
                  <div className="name_label">
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="arrow_icon"
                    />
                    <div className="name_area">
                      <FontAwesomeIcon
                        icon={['fas', 'list']}
                        className="icon task"
                      />
                      メンバー一覧
                    </div>
                  </div>
                </Link>
                {
                  risk.riskMembers?.members.filter((v) => v.active).map((member) => (
                    <React.Fragment key={`side_sub_${member.name}`}>
                      <Link
                        to={setPath(setUrlId(URL.RISK_MEMBER_DETAIL.path, "id", member.id), language)}
                        className={classNames({
                          active: location.pathname.match(setPath(setUrlId(URL.RISK_MEMBER_DETAIL.path, "id", member.id), language)),
                          item: true,
                          indent_1: true,
                        })}
                      >
                        <div className="name_label">
                          <FontAwesomeIcon
                            icon={['fas', 'angle-right']}
                            className="arrow_icon"
                          />
                          <div className="name_area">
                            <img
                              alt=""
                              src={member.profile_image || `/static/images/profile/${member.id % 12 || 0}.jpeg`}
                              className="icon"
                            />
                            {member.name}
                          </div>
                        </div>
                      </Link>
                    </React.Fragment>
                  ))
                }
              </div>
              <div
                className="item folder"
                onClick={() => setIsOpenTeam(!isOpenTeam)}
                role="none"
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-down']}
                    className={`arrow_icon ${isOpenTeam && "open"}`}
                  />
                  <div className="name_area">
                    <FontAwesomeIcon
                      icon={['fas', 'users']}
                      className="icon task"
                    />
                    チームデータ
                  </div>
                </div>
              </div>
              <div className={`${isOpenTeam || "hidden none"}`}>
                <Link
                  to={setPath(URL.RISK_TEAM_LIST.path, language)}
                  className={classNames({
                    active: location.pathname.match(URL.RISK_TEAM_LIST.path),
                    item: true,
                    indent_1: true,
                  })}
                >
                  <div className="name_label">
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="arrow_icon"
                    />
                    <div className="name_area">
                      <FontAwesomeIcon
                        icon={['fas', 'list']}
                        className="icon task"
                      />
                      チーム一覧
                    </div>
                  </div>
                </Link>
                {
                  risk.riskTeams?.teams.map((team) => (
                    <React.Fragment key={`side_sub_${team.name}`}>
                      <Link
                        to={setPath(setUrlId(URL.RISK_TEAM_DETAIL.path, "id", team.id), language)}
                        className={classNames({
                          active: location.pathname.match(setPath(setUrlId(URL.RISK_TEAM_DETAIL.path, "id", team.id), language)),
                          item: true,
                          indent_1: true,
                        })}
                      >
                        <div className="name_label">
                          <FontAwesomeIcon
                            icon={['fas', 'angle-right']}
                            className="arrow_icon"
                          />
                          <div className="name_area">
                            <FontAwesomeIcon
                              icon={['fas', 'users']}
                              className="icon task"
                            />
                            {team.name}
                          </div>
                        </div>
                      </Link>
                    </React.Fragment>
                  ))
                }
              </div>
            </section>
          </div>
        ) : (
          <>
          </>
        )
      }
    </>
  )
}

export default SideBarSubRisk
